import type { ExternalRoute, PageRoute } from "@/shared/navigation";
import { RobotoEndpoint } from "@/types";

export enum Title {
  Account = "Account settings",
  Actions = "Actions",
  ActionHub = "Action Hub",
  Admin = "Admin",
  Collections = "Collections",
  Devices = "Devices",
  Docs = "Docs",
  Invite = "Invite members",
  Home = "Home",
  Logout = "Log out",
  NewDataset = "New Dataset",
  Notifications = "Notifications",
  Organization = "Organization settings",
  Search = "Search",
  Settings = "Settings",
  SwitchOrg = "Switch organization",
}

export enum Alignment {
  Left = "left",
  Right = "right",
  Center = "center",
}

export interface RobotoNavigationProps {}

export interface NavItemData {
  title: Title;
  link: PageRoute | ExternalRoute;
  alignment: Alignment;
  target?: string;
  Icon: React.ElementType;
}

export const notificationsEndpoint: RobotoEndpoint = (pathParams) => {
  if (pathParams && pathParams.notificationId) {
    return `/notifications/${pathParams.notificationId}`;
  }

  return `/notifications`;
};

export const getCommentEndpoint: RobotoEndpoint = (pathParams) => {
  if (pathParams && pathParams.commentId) {
    return `/comments/${pathParams.commentId}`;
  }

  throw new Error("No commentId provided");
};
